import { SupportedChainId as ChainId } from "../constants/chains";

// Multichain Explorer
const builders = {
  etherscan: (
    chainName: string,
    data: string,
    type: "transaction" | "token" | "address" | "block"
  ) => {
    const prefix = `https://${chainName ? `${chainName}.` : ""}etherscan.io`;
    switch (type) {
      case "transaction":
        return `${prefix}/tx/${data}`;
      default:
        return `${prefix}/${type}/${data}`;
    }
  },

  bscscan: (
    chainName: string,
    data: string,
    type: "transaction" | "token" | "address" | "block"
  ) => {
    const prefix = `https://${chainName ? `${chainName}.` : ""}bscscan.com`;
    switch (type) {
      case "transaction":
        return `${prefix}/tx/${data}`;
      default:
        return `${prefix}/${type}/${data}`;
    }
  },

  fuji: (
    chainName: string,
    data: string,
    type: "transaction" | "token" | "address" | "block"
  ) => {
    const prefix = `https://${chainName ? `${chainName}.` : ""}snowtrace.io`;
    switch (type) {
      case "transaction":
        return `${prefix}/tx/${data}`;
      default:
        return `${prefix}/${type}/${data}`;
    }
  },

  avax: (
    chainName: string,
    data: string,
    type: "transaction" | "token" | "address" | "block"
  ) => {
    const prefix = `https://${chainName ? `${chainName}.` : ""}snowtrace.io`;
    switch (type) {
      case "transaction":
        return `${prefix}/tx/${data}`;
      default:
        return `${prefix}/${type}/${data}`;
    }
  },

  // token is not yet supported for arbitrum
  arbitrum: (
    chainName: string,
    data: string,
    type: "transaction" | "token" | "address" | "block"
  ) => {
    const prefix = `https://arbiscan.io`;
    switch (type) {
      case "transaction":
        return `${prefix}/tx/${data}`;
      default:
        return `${prefix}/${type}/${data}`;
    }
  },
};

interface ChainObject {
  [chainId: number]: {
    chainName: string;
    builder: (
      chainName: string,
      data: string,
      type: "transaction" | "token" | "address" | "block"
    ) => string;
  };
}

const chains: ChainObject = {
  [ChainId.BSC]: {
    chainName: "",
    builder: builders.bscscan,
  },
  [ChainId.FUJI]: {
    chainName: "testnet",
    builder: builders.fuji,
  },
  [ChainId.AVAX]: {
    chainName: "",
    builder: builders.avax,
  },
};

export function getExplorerLink(
  chainId: ChainId,
  data: string,
  type: "transaction" | "token" | "address" | "block"
): string {
  const chain = chains[chainId];
  return chain?.builder(chain.chainName, data, type);
}
